import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const features = [
  "No upfront onboarding fee for qualified clinics",
  "Licensed provider network and 503A/503B pharmacy pathway support",
  "Lab partner integration and diagnostics pathways",
  "GLP-1, peptide pathway support, and NAD+ wellness routing",
  "Hormone optimization and performance-health infrastructure",
  "Telehealth infrastructure and multi-state provider support",
  "Medical director pathway assistance",
  "Compliance-aware vendor routing — not personal sourcing",
];

const clinicTypes = [
  "Med Spas", "Men's Health Clinics", "Hormone Clinics", "Weight-Loss Clinics",
  "Longevity Clinics", "Telehealth Companies", "Primary Care + Functional Medicine",
  "Sports Recovery Practices",
];

export default function ForClinics() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="pt-28 pb-16 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-600 mb-4">For Clinics</p>
          <h1 className="text-5xl font-medium text-slate-900 mb-5" style={{ fontFamily: 'Outfit, sans-serif' }}>
            For clinics ready to build smarter
          </h1>
          <p className="text-xl text-slate-600 mb-8">
            For med spas, men's health clinics, weight-loss clinics, longevity practices, hormone clinics, and telehealth groups. Apexum helps clinics navigate vendor-side performance health.
          </p>
          <Link to="/talk-to-ava"
            className="inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-3.5 rounded-full font-medium hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/25">
            See If Your Clinic Qualifies <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="text-3xl font-medium text-slate-900 mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              What Apexum provides
            </h2>
            <div className="space-y-3">
              {features.map((f, i) => (
                <div key={i} className="flex items-start gap-3">
                  <CheckCircle size={18} className="text-emerald-500 mt-0.5 flex-shrink-0" />
                  <p className="text-slate-700 text-sm leading-relaxed">{f}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h2 className="text-3xl font-medium text-slate-900 mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Designed for
            </h2>
            <div className="grid grid-cols-2 gap-3">
              {clinicTypes.map((t, i) => (
                <div key={i} className="bg-blue-50 rounded-2xl px-4 py-3 text-sm font-medium text-blue-800 border border-blue-100">
                  {t}
                </div>
              ))}
            </div>
            <div className="mt-8 p-5 bg-amber-50 rounded-2xl border border-amber-100">
              <p className="text-xs font-semibold text-amber-700 uppercase tracking-wide mb-2">Compliance Notice</p>
              <p className="text-sm text-amber-900">
                Apexum does not provide medical advice, prescribe medication, or route consumers to research-use-only products for human use. All pathways require provider review and applicable qualification.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
